<template>
  <v-card class="aggregate-information">
    <div
      class="aggregate-container"
      v-for="data in aggregateData"
      :key="data.id"
    >
      <div class="aggregate-contents">
        <div class="aggregate-contents-labels">
          <v-img class="aggregate-contents-icon" :src="data.icon" />
          <div class="aggregate-contents-label">{{ $t(data.label) }}</div>
        </div>
        <div class="aggregate-contents-detail">
          <div class="aggregate-contents-count">
            {{ getCount(data.countKey) }}
          </div>
          <div class="aggregate-contents-amount">
            {{ getAmount(data.amountKey) }}
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { commonUtil, currencyUtil } from '@/util'

export default {
  data() {
    return {
      aggregateData: [
        {
          id: 1,
          label: 'common.common_order-this-month',
          icon: require('../../../assets/icon_order_gray.svg'),
          amountKey: 'currentMonthOrderAmount',
          countKey: 'currentMonthOrderCount'
        },
        {
          id: 2,
          label: 'common.common_order-not-completed',
          icon: require('../../../assets/icon_order_gray.svg'),
          amountKey: 'orderIncompleteAmount',
          countKey: 'orderIncompleteCount'
        },
        {
          id: 3,
          label: 'common.common_sale-this-month',
          icon: require('../../../assets/icon_sale_gray.svg'),
          amountKey: 'currentMonthSaleAmount',
          countKey: 'currentMonthSaleCount'
        },
        {
          id: 4,
          label: 'common.common_not-sold',
          icon: require('../../../assets/icon_sale_gray.svg'),
          amountKey: 'saleIncompleteAmount',
          countKey: 'saleIncompleteCount'
        },
        {
          id: 5,
          label: 'common.common_current-theoretical-inventory',
          icon: require('../../../assets/icon_storage_gray.svg'),
          amountKey: 'logicalStockAmount',
          countKey: 'logicalStockQuantity'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('BalanceOfPayment', ['getBalanceOfPaymentListFromState']),
    balanceOfPayment() {
      return this.getBalanceOfPaymentListFromState[0]
    }
  },
  methods: {
    getCount(key) {
      if (!this.balanceOfPayment) {
        return 0
      }
      if (!this.balanceOfPayment[key]) {
        return 0
      }
      return this.balanceOfPayment[key]
    },
    getAmount(key) {
      if (!this.balanceOfPayment) {
        return ''
      }
      if (!this.balanceOfPayment[key]) {
        return ''
      }
      const { currencyId } = this.balanceOfPayment
      const unit = currencyUtil.getCurrencyUnitName(currencyId)
      const amount = commonUtil.formatPrice(this.balanceOfPayment[key])
      return `${commonUtil.formatPrice(amount).toLocaleString()} ${unit}`
    }
  }
}
</script>

<style lang="scss" scoped>
.aggregate {
  &-information {
    width: 100%;
    height: 98px;
    display: flex;
    padding: 15px;
  }

  &-container {
    width: 20%;
    max-width: 20%;
  }

  &-contents {
    padding: 5px 10px;
    width: 163px;
    max-width: 163px;

    &-detail {
      display: flex;
      padding-top: 8px;
    }

    &-labels {
      display: flex;
      color: #666666;
    }

    &-icon {
      max-width: 20px !important;
      height: 20px;
    }

    &-label {
      padding-top: 2px;
      margin-left: 4px;
    }

    &-count {
      font-size: 20px;
      margin-right: 8px;
      color: #333333;
      font-weight: bold;
    }

    &-amount {
      padding-top: 6px;
      color: #999999;
      white-space: nowrap;
    }
  }
}
</style>
